import OHIF from '@ohif/core';
import cornerstone from 'cornerstone-core';
import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import dicomParser from 'dicom-parser';
import version from './version.js';
import { applyOrthancAuthHeaders } from '@ohif/core/src/utils/orthancAPI';

// Configure global app info, cornerstone loaders and HTTP error handling
export function setConfiguration(appConfig) {
  // App info exposed on window
  let homepage;
  const { process } = window;
  if (process && process.env && process.env.PUBLIC_URL) {
    homepage = process.env.PUBLIC_URL;
  }

  window.info = {
    version,
    homepage,
  };

  // For debugging
  window.cornerstone = cornerstone;
  window.cornerstoneWADOImageLoader = cornerstoneWADOImageLoader;

  // Cornerstone WADO image loader dependencies
  cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
  cornerstoneWADOImageLoader.external.dicomParser = dicomParser;

  // HTTP error handler provided by the app configuration
  OHIF.errorHandler.getHTTPErrorHandler = () => {
    return appConfig.httpErrorHandler;
  };

  cornerstoneWADOImageLoader.configure({
    // No-op offline: the same-origin launcher proxy injects the credentials.
    beforeSend: applyOrthancAuthHeaders,
    errorInterceptor: error => {
      if (typeof appConfig.httpErrorHandler === 'function') {
        appConfig.httpErrorHandler(error);
      }
    },
  });
}
